<template>
  <div class="wrapper short box" :class="{ upwardTrend: trend == 'rising', downwardTrend: trend == 'falling', neutralTrend: trend == 'neutral' }">
    <b-icon class="trendIcon" v-if="trend == 'rising'" icon="arrow-top-right" size="is-large" type="is-success"></b-icon>
    <b-icon class="trendIcon" v-else-if="trend == 'falling'" icon="arrow-bottom-right" size="is-large" type="is-danger"></b-icon>
    <b-icon class="trendIcon" v-else-if="trend == 'neutral'" icon="arrow-right" size="is-large" type="is-warning"></b-icon>
    <div class="title">{{ this.mode }}</div>
    <div v-if="dayMode == 'current'" class="conversionWrapper">
      <div class="progressWrapper">
        <rounded-percentage :progress.sync="this.hourConversionRate" :radius="50"></rounded-percentage>
        <div>Hour before</div>
      </div>
      <div class="progressWrapper">
        <rounded-percentage :progress.sync="this.ConversionRate" :radius="50"></rounded-percentage>
        <div>Last Hour</div>
      </div>
    </div>
    <div v-else class="conversionWrapper">
      <div class="progressWrapper">
        <rounded-percentage :progress.sync="this.ConversionRate" :radius="50"></rounded-percentage>
        <div>Day Summary</div>
      </div>
    </div>
  </div>
</template>

<script>
import RoundedPercentage from "@/components/common/RoundedPercentageComponent.vue";
const dayjs = require("dayjs");
export default {
  components: {
    RoundedPercentage,
  },
  props: {
    stats: {
      type: Object,
      required: true,
    },
    customers: {
      type: Array,
      required: true,
    },
    mode: {
      type: String,
      required: false,
      default: "average",
    },
    selectedDate: {
      type: Date,
      required: true,
    },
    dayMode: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      ConversionRate: 0,
      hourConversionRate: 0,
      fullybooked: 0,
      hourFullyBooked: 0,
      fullyBookedPercent: 0,
      hourFullyBookedPercent: 0,
      trend: "neutral",
      formattedSelectedDate: dayjs(this.selectedDate),
      outcomeTotals: [],
    };
  },
  methods: {
    CalculateActualConversionRate: async function () {
      let today = this.stats[this.formattedSelectedDate.format("DD-MM-YYYY")];
      let yesterday = this.stats[dayjs(this.selectedDate).subtract(1, "day").format("DD-MM-YYYY")];
      let hourBefore = {};
      if (Object.keys(today).length < 2) {
        //New day
        hourBefore = yesterday[Object.keys(yesterday)[Object.keys(yesterday).length - 1]];
      } else {
        hourBefore = today[Object.keys(today)[Object.keys(today).length - 2]];
      }
      let mostRecent = today[Object.keys(today)[Object.keys(today).length - 1]];
      let totalBooked = 0;
      let totalCalls = 0;
      for (const [customerId, customerData] of Object.entries(mostRecent)) {
        if (this.customers[customerId] === undefined || this.customers[customerId].type == "dev" || this.customers[customerId].type == "demo") {
          continue;
        }
        for (const [outcome, amount] of Object.entries(customerData)) {
          if (outcome == "Booked" || outcome == "booked") {
            totalBooked += amount;
          } else if (outcome == "fullybooked" || outcome == "fully_booked") {
            this.fullybooked += amount;
          } else if (outcome.toLowerCase() == "bookablesessions") {
            totalCalls += amount;
          }
        }
        this.ConversionRate = parseInt(((totalBooked / totalCalls) * 100).toFixed());
        this.fullyBookedPercent = parseInt(((this.fullybooked / totalCalls) * 100).toFixed());
      }
      let hourBeforeBooked = 0;
      let hourBeoforeCalls = 0;
      for (const [customerId, customerData] of Object.entries(hourBefore)) {
        if (this.customers[customerId] === undefined || this.customers[customerId].type == "dev" || this.customers[customerId].type == "demo") {
          continue;
        }
        for (const [outcome, amount] of Object.entries(customerData)) {
          if (outcome == "Booked" || outcome == "booked") {
            hourBeforeBooked += amount;
          } else if (outcome == "fullybooked" || outcome == "fully_booked") {
            this.hourFullyBooked += amount;
          } else if (outcome.toLowerCase() == "bookablesessions") {
            hourBeoforeCalls += amount;
          }
        }
        this.hourConversionRate = parseInt(((hourBeforeBooked / hourBeoforeCalls) * 100).toFixed());
        this.hourFullyBookedPercent = parseInt(((this.hourFullyBooked / hourBeoforeCalls) * 100).toFixed());
      }
      if (this.ConversionRate > this.hourConversionRate) {
        this.trend = "rising";
      } else if (this.ConversionRate < this.hourConversionRate) {
        this.trend = "falling";
      } else {
        this.trend = "neutral";
      }
    },
    CalculateAverageConversionRate: async function () {
      let today = this.stats[Object.keys(this.stats)[Object.keys(this.stats).length - 1]];
      let yesterday = this.stats[Object.keys(this.stats)[Object.keys(this.stats).length - 2]];
      let lastHour = {};
      let hourBefore = {};
      if (Object.keys(today).length < 2) {
        //New day, grab last entry from previous day
        lastHour = today[Object.keys(today)[Object.keys(today).length - 1]];
        hourBefore = yesterday[Object.keys(yesterday)[Object.keys(yesterday).length - 1]];
      } else {
        lastHour = today[Object.keys(today)[Object.keys(today).length - 1]];
        hourBefore = today[Object.keys(today)[Object.keys(today).length - 2]];
      }

      let ConversionRate = 0;
      let fullyBooked = 0;
      let count = 0;

      for (const [key, value] of Object.entries(lastHour)) {
        if (value.bookableSessions === 0) continue;
        if (typeof value.booked === "undefined") value.booked = 0;
        if (typeof value.fully_booked !== "undefined") fullyBooked += (value.fully_booked / value.bookableSessions) * 100;
        ConversionRate += (value.booked / value.bookableSessions) * 100;
        count++;
      }

      this.ConversionRate = parseInt((ConversionRate / count).toFixed(0));
      this.fullybooked = fullyBooked;
      this.fullyBookedPercent = (fullyBooked / count).toFixed(0);
      ConversionRate = 0;
      fullyBooked = 0;
      count = 0;

      for (const [key, value] of Object.entries(hourBefore)) {
        if (value.bookableSessions === 0) continue;
        if (typeof value.booked === "undefined") value.booked = 0;
        if (typeof value.fully_booked !== "undefined") fullyBooked += value.fully_booked;
        ConversionRate += (value.booked / value.bookableSessions) * 100;
        count++;
      }

      this.hourConversionRate = parseInt((ConversionRate / count).toFixed(0));
      this.hourFullyBooked = fullyBooked;
      this.hourFullyBookedPercent = (fullyBooked / count).toFixed(0);
      if (this.ConversionRate > this.hourConversionRate) {
        this.trend = "rising";
      } else if (this.ConversionRate < this.hourConversionRate) {
        this.trend = "falling";
      } else {
        this.trend = "neutral";
      }
    },
    CalculateDailyConversion: async function () {
      let today = this.stats[this.formattedSelectedDate.format("DD-MM-YYYY")];
      for (const [time, customerData] of Object.entries(today)) {
        for (const [customerId, data] of Object.entries(customerData)) {
          for (const [outcome, value] of Object.entries(data)) {
            let foundOutcome = this.outcomeTotals.find((outcomeSearch) => {
              return outcomeSearch.name == outcome;
            });
            if (!foundOutcome) {
              this.outcomeTotals.push({ name: outcome, value: value });
            } else {
              foundOutcome.value += value;
            }
          }
        }
      }
      let bookableSessions = this.outcomeTotals.find((outcomeSearch) => {
        return outcomeSearch.name.toLowerCase() == "bookablesessions";
      });
      let bookableSessionsTotal = 0;
      if (bookableSessions) bookableSessionsTotal = bookableSessions.value;

      let bookedCalls = this.outcomeTotals.find((outcomeSearch) => {
        return outcomeSearch.name.toLowerCase() == "booked";
      });
      let bookedTotal = 0;
      if (bookedCalls) bookedTotal = bookedCalls.value;
      this.ConversionRate = ((bookedTotal / bookableSessionsTotal) * 100).toFixed();
    },
  },
  mounted() {
    if (this.dayMode != "historic") {
      if (this.mode && this.mode == "actual") {
        this.CalculateActualConversionRate();
      } else {
        this.CalculateAverageConversionRate();
      }
    } else {
      this.CalculateDailyConversion();
    }
  },
};
</script>

<style scoped>
#CurrentConversionRate {
  font-size: calc(2.5vw - 1vh);
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
}
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2em;
  text-transform: capitalize;
}
.title.sub {
  font-size: min(5vw, 30px);
}
.conversionWrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.progressWrapper {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.trendIcon {
  position: absolute;
  top: 5px;
  right: 5px;
}
.box.upwardTrend {
  background-color: #d2ffd2;
}
.box.neutralTrend {
  background-color: #e2e5ffa8;
}
.box.downwardTrend {
  background-color: #ffe2e2;
}
.wrapper .box {
  box-shadow: unset;
}
</style>
